module.exports = __webpack_public_path__ + "static/Robert_900x900-5ec7446cb1b5c6fe0bcdfcef45d71f93.png";